export const blockIconsActivitiesToysNew = (
	<span className='material-symbols-outlined'>toys</span>
);
